import { useState } from "react";
import { Icon } from "@iconify/react";
import { useSnackbar } from "notistack5";
import copyFill from "@iconify/icons-eva/copy-fill";
import { CopyToClipboard } from "react-copy-to-clipboard";
// material
import { Tooltip, TextField, IconButton, InputAdornment, IconButtonProps } from "@material-ui/core";
import { CopyAll } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

type CopyClipboardProps = {
  value: string;
  disabled?: boolean;
  color?:
    | "action"
    | "disabled"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  iconSize?: number;
};

export default function CopyClipboard({ value, disabled, color, iconSize }: CopyClipboardProps) {
  const { enqueueSnackbar } = useSnackbar();
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const onCopy = () => {
    setCopied(true);
    enqueueSnackbar(t("general.copiedSuccesfully"), { variant: "success" });

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <CopyToClipboard text={value} onCopy={onCopy}>
      <Tooltip title={t("general.copy")}>
        <IconButton disabled={disabled}>
          <CopyAll sx={{ fontSize: iconSize }} color={disabled ? "disabled" : copied ? "success" : color ?? "secondary"} />
        </IconButton>
      </Tooltip>
    </CopyToClipboard>
  );
}
